import { Component, OnInit } from "@angular/core";
import { CoreConfigService } from "../../../../@core/services/config.service";
import { UtilsService } from "../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../auth/service";
import { Router } from "@angular/router";
import { TutorialService } from "../../../auth/service/tutorial.service";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-iban",
  templateUrl: "./iban.component.html",
  styleUrls: ["./iban.component.scss"],
})
export class IbanComponent implements OnInit {
  public coreConfig: any;

  public currentUser: ICurrentUser;

  public iban: any = null;

  public user_profile: any;

  public showError: boolean = false;

  /**
     * Constructor
     *
     * @param {CoreConfigService} _coreConfigService
     *

     * @param _utilService
     * @param _userService
     * @param _authenticationService
     * @param _router
     * @param _tutorialService
     */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _utilService: UtilsService,
    private _userService: UserService,
    private _authenticationService: AuthenticationService,
    private _router: Router,
    public _tutorialService: TutorialService,
  ) {
    this._utilService.disableAutoHideLoading();
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  async ngOnInit() {
    this.currentUser = this._authenticationService.getCurrentUser();
    if (this.currentUser && this.currentUser.send_onboarding === 1) {
      await this._router.navigateByUrl("/dashboard/main");
      this._utilService.hideLoading();
      return false;
    }
    this.user_profile = await this._userService.get(this.currentUser.hash);
    if (this.user_profile && this.user_profile.IBAN && this.user_profile.IBAN.length > 0) {
      this.iban = this.user_profile.IBAN;
    }
    this._utilService.hideLoading();
  }

  async save() {
    if (!!this.iban) {
      this.iban = this.iban.trim();
    }
    if (!this.iban || this.iban.length != 27) {
      this.showError = true;
      return false;
    }
    this._utilService.showLoading();
    return this._userService
      .update(this.currentUser.hash, { IBAN: this.iban })
      .then(() => this._router.navigateByUrl("/onboarding/documents"))
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_INSERT_IBAN" });
      });
  }

  showVideo() {
    this._tutorialService.video_to_play = "Onboarding";
    this._tutorialService.force_open_modal = true;
  }
}
